import classNames from 'classnames';
import { bool, func, string } from 'prop-types';
import { Component } from 'react';

import * as criterias from 'atg/constants/CouponCriteria';
import CornerLoader from 'shared/components/loader/CornerLoader';
import * as Text from 'shared/utils/Text';

export default class CouponsForm extends Component {
  static propTypes = {
    onCreateClick: func.isRequired,
    onChangeCriteria: func.isRequired,
    isLoading: bool.isRequired,
    betResultStarted: bool.isRequired,
    betResultComplete: bool.isRequired,
    criteria: string,
  };

  onSubmit = e => {
    const { onCreateClick, criteria } = this.props;

    e.preventDefault();

    if (criteria) {
      onCreateClick();
    }
  };

  onChangeSelected = e => {
    this.props.onChangeCriteria(e.target.value);
  };

  render() {
    const { criteria, isLoading, betResultStarted, betResultComplete } =
      this.props;

    let radios = [];

    if (betResultStarted) {
      radios = [
        {
          value: criterias.ALL,
          label: Text.get('dialog-coupons-all'),
        },
        {
          value: criterias.CORRECT_ONLY,
          label: betResultComplete
            ? Text.get('dialog-coupons-correct-only')
            : Text.get('dialog-coupons-potential-correct-only'),
        },
        {
          value: criterias.MAX_ONE_ERROR,
          label: betResultComplete
            ? Text.get('dialog-coupons-max-one-error')
            : Text.get('dialog-coupons-potential-max-one-error'),
        },
        {
          value: criterias.MAX_TWO_ERRORS,
          label: betResultComplete
            ? Text.get('dialog-coupons-max-two-errors')
            : Text.get('dialog-coupons-potential-max-two-errors'),
        },
      ];
    }

    return (
      <div
        className={classNames('dialog-coupons-form', {
          'dialog-coupons-form--unstarted': !betResultStarted,
        })}
      >
        <p className="text">{Text.get('dialog-coupons-text')}</p>
        <form onSubmit={this.onSubmit}>
          <CornerLoader visible={isLoading} />

          <h2>{Text.get('dialog-coupons-form-heading')}</h2>
          {radios.map(({ value, label }) => (
            <div key={value} className="dialog-coupons-radio-container">
              <input
                type="radio"
                name="criteria"
                id={`rdio-${value}`}
                value={value}
                checked={value === criteria}
                disabled={isLoading}
                onChange={this.onChangeSelected}
              />
              <label htmlFor={`rdio-${value}`}>{label}</label>
            </div>
          ))}
          <button type="submit" disabled={!criteria || isLoading}>
            {Text.get('dialog-coupons-form-button')}
          </button>
        </form>
      </div>
    );
  }
}
